import {z} from 'zod'
import {validateState} from '../ValidateState.ts'
import {PlayerColor} from '../PlayerState.ts'
import {TileEdgeDirection} from './TileEdgeState.ts'

export enum TileEdgePortType {
    Port = 1,
    PortLumber = 2,
    PortBrick = 3,
    PortWool = 4,
    PortGrain = 5,
    PortOre = 6,
}

export const portEdgeStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        z: z.enum(TileEdgeDirection).readonly(),
        type: z.enum(TileEdgePortType).readonly(),
        owner: z.enum(PlayerColor).exclude(['None']).optional(),
    })
    .strict()

export type PortEdgeState = z.infer<typeof portEdgeStateSchema>

export function validatePortEdgeState(data: unknown) {
    return validateState(portEdgeStateSchema, data)
}

export const portEdgeStatePartialSchema = portEdgeStateSchema.partial().refine((obj) => Object.keys(obj).length > 0, {
    message: 'At least one property must be provided',
})

export type PortEdgeStatePartial = z.infer<typeof portEdgeStatePartialSchema>

export function validatePortEdgeStatePartial(data: unknown) {
    return validateState(portEdgeStatePartialSchema, data)
}
